import AttendeeType from 'owa-service/lib/contract/AttendeeType';

export default function getUniqueAttendees(attendees: AttendeeType[]) {
    if (!attendees || attendees.length == 0) {
        return attendees;
    }

    // Convert to object (dictionary) to filter out duplicates
    let attendeesDictionary: Object = {};

    attendees.forEach(attendee => {
        attendeesDictionary[attendee.Mailbox.EmailAddress] = attendee;
    });

    // Convert back into array
    return Object.keys(attendeesDictionary).map(key => attendeesDictionary[key]);
}
